﻿import { CommentFile } from "../administration/complaint-configuration/comment-file";

export class ComplaintComment {
    id: number;
    comment: string;
    dateCreated: Date;
    userName: string;
    complaintId: number;
    userId: number;
    languageId: number;
    pictureUrl: string;
    active: boolean;
    inappropriate: boolean;
    complaintCommentFile: CommentFile[];
    
    constructor() {
        this.complaintCommentFile = [];
    }
}